import { useAuthStore } from '../auth/store';
import type { UserFeatures } from '../api/models/userFeatures';

/**
 * Hook to access user feature flags from the auth store
 */
export const useUserFeatures = () => {
  const flags = useAuthStore((state) => state.user?.features || {});

  /**
   * Check if a specific feature flag is active
   */
  const isFeatureActive = (flagName: string): boolean => !!flags[flagName];

  return {
    flags,
    isFeatureActive,
  };
};

/**
 * Utility function to check if a feature flag is active from a flags object
 * Useful for when you already have the flags object or are outside of a component
 */
export const isFeatureFlagActive = (flags: UserFeatures | undefined, flagName: string): boolean => !!(flags && flags[flagName]);
